import { render, staticRenderFns } from "./EmailSettingsTab.vue?vue&type=template&id=4a35c168&scoped=true"
import script from "./EmailSettingsTab.vue?vue&type=script&lang=js"
export * from "./EmailSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./EmailSettingsTab.vue?vue&type=style&index=0&id=4a35c168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a35c168",
  null
  
)

export default component.exports